/** @file dock-manager/BlackoutBar.jsx — top-lane summary bar for a blackout. */
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { BLACKOUT_ROLE_STYLE } from "@/lib/constants";
import { fmtRange } from "./formatters";

export default function BlackoutBar({ blackout, windowStart, windowEnd, pxPerHour }) {
  const start = new Date(blackout.start_time);
  const end = new Date(blackout.end_time);
  const visStart = start < windowStart ? windowStart : start;
  const visEnd = end > windowEnd ? windowEnd : end;
  if (visEnd <= visStart) return null;
  const leftHours = (visStart - windowStart) / 3600 / 1000;
  const widthHours = (visEnd - visStart) / 3600 / 1000;
  const style = BLACKOUT_ROLE_STYLE[blackout.created_by_role] || BLACKOUT_ROLE_STYLE.default;
  return (
    <div
      className="absolute top-1 bottom-1 rounded"
      style={{
        left: leftHours * pxPerHour,
        width: widthHours * pxPerHour,
        backgroundColor: style.bg,
        boxShadow: `inset 0 0 0 1px ${style.ring}`,
      }}
      title={blackout.title || blackout.reason || "Blackout"}
      data-testid={`blackout-${blackout.id}`}
    >
      <div className="text-[10px] text-slate-800 truncate px-1.5 py-1">
        {blackout.title || blackout.reason || "Closed"}
      </div>
    </div>
  );
}

